﻿/*
 * Created on Mon Nov 19 2018
 *
 * Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
 */
export class User {
    username: string;
    password: string;
    firstName: string;
    lastName: string;
}

export class KermetPayload {
    clienteol: number;
    username: string;
    email: string;
    empresa: string;
    idusuariokermet: number;
    legajo: number;
    nombre: string;
    usuario: string;
    usuariokermet: string;
    vendedor: string;
    statussalida: string;
    ctimestamp: number;
}

export class Payload {
    iat: number;
    exp: number;
    sub: number;
    nonce: string;
    reqIp: string;
    kermetPayload: KermetPayload;
}

export class CovetcbaRequest {
    constructor(public usuario: string = "",
                public hash: string = "",
                public nonce: number = 0) {
    }
}

export class RestorePasswordRequest {
    constructor(public email: string = "") {
    }
}

export class RestorePasswordResponse {
    constructor(public mensaje: string = "") {
    }
}

export class ResetPasswordRequest extends CovetcbaRequest {
    constructor(usuario: string = "",
                hash: string = "",
                nonce: number = 0,
                public resetid: string = "") {
        super(usuario, hash, nonce)
    }
}


export class Matricula {

}

export class VentaRegistro {
    formulario: string;
    fecha: number;
    asociado: number;
    razon_soci: string;
    origen: number;
    tipo: string;
    nrocomprob: number;
    monto_tota: number;
    saldo: number;
    fec_vcto: string;
    estado: string;
    observacio: string;
    interes: number;
    codbarpf: string;
    pago_facil: string;
    codpf: string;
    downloading: boolean;
    observacion: string;

    constructor() {
        this.downloading = false;
    }

}

export class VentaRespuesta {
    statussalida: string;
    ctimestamp: number;
    registros: VentaRegistro[];
    proximoRangoRegistros: string;
}
